const ComparisonMode = Object.freeze({
  TOPICS: 'TOPICS',
  THEMES: 'THEMES',
  TAGS: 'TAGS',
  DOC_HIERARCHIES: 'DOC_HIERARCHIES',
  NONE: 'NONE'
})
export default ComparisonMode
// RESERVE BELOW
export type ComparisonModeStrings = typeof ComparisonMode[keyof typeof ComparisonMode]
